<button type="button" [routerLink]="['/auction/manage-filters']" class="btn pl-0 pt-1 pr-0 font-md d-flex justify-content-between align-items-center w-100">
  Create Custom Filters<i class="btn fa fa-angle-right text-red font-lg" aria-hidden="true"></i>
</button>
<ul class="pl-0 pt-1">
  <li *ngFor="let value of model" class="d-flex align-items-center justify-content-between w-100 text-opacity-7" (click)="apply(value)">
    {{value.Name}}
    <button type="button" class="btn pr-0 py-0" (click)="remove(value); $event.stopPropagation()" aria-title="Delete filter">
      <i class="btn fa fa-times-circle text-red font-md" aria-hidden="true"></i>
    </button>
  </li>
</ul>
